import React, { Fragment } from 'react';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { AvailableContext } from '../use-available-contexts';
import { DetailsSourceItem, DetailsSourceItemSkeleton } from './details-source-item';
import css from './details-sources-list.module.scss';

interface DetailsSourcesListProps {
  asset: Asset;
  availableContexts: AvailableContext[];
}

export function DetailsSourcesList({ asset, availableContexts }: DetailsSourcesListProps) {
  return (
    <Swimlane className={css.container}>
      <Swimlane.Slider className={css.slider}>
        {availableContexts.map((context) => (
          <DetailsSourceItem key={context.id} asset={asset} context={context} />
        ))}
      </Swimlane.Slider>
    </Swimlane>
  );
}

export function DetailsSourcesListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <Fragment>
      {Array.from({ length: count }, (_, i) => (
        <DetailsSourceItemSkeleton key={i} />
      ))}
    </Fragment>
  );
}
